var _g, _path, _g2, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadgesDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8381_49582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 31.4286C6 26.7731 9.7731 23 14.4286 23H56.5714C61.2203 23 65 26.7731 65 31.4286V73.5714C65 78.2203 61.2203 82 56.5714 82H14.4286C9.7731 82 6 78.2203 6 73.5714V31.4286Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4286 22C9.22082 22 5 26.2208 5 31.4286V73.5714C5 78.7721 9.22031 83 14.4286 83H56.5714C61.7726 83 66 78.7726 66 73.5714V31.4286C66 26.2203 61.7721 22 56.5714 22H14.4286Z",
    stroke: "white",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4598 68.1719H48.1429V39.2711C48.1429 38.431 47.4353 37.75 46.5625 37.75H24.4375C23.5647 37.75 22.8571 38.431 22.8571 39.2711V68.1719H21.5402C21.1038 68.1719 20.75 68.5124 20.75 68.9324V70.2H50.25V68.9324C50.25 68.5124 49.8962 68.1719 49.4598 68.1719ZM29.1786 42.5668C29.1786 42.1468 29.5324 41.8063 29.9688 41.8063H32.6027C33.0391 41.8063 33.3929 42.1468 33.3929 42.5668V45.102C33.3929 45.522 33.0391 45.8625 32.6027 45.8625H29.9688C29.5324 45.8625 29.1786 45.522 29.1786 45.102V42.5668ZM29.1786 48.6512C29.1786 48.2312 29.5324 47.8906 29.9688 47.8906H32.6027C33.0391 47.8906 33.3929 48.2312 33.3929 48.6512V51.1863C33.3929 51.6063 33.0391 51.9469 32.6027 51.9469H29.9688C29.5324 51.9469 29.1786 51.6063 29.1786 51.1863V48.6512ZM32.6027 58.0313H29.9688C29.5324 58.0313 29.1786 57.6907 29.1786 57.2707V54.7355C29.1786 54.3155 29.5324 53.975 29.9688 53.975H32.6027C33.0391 53.975 33.3929 54.3155 33.3929 54.7355V57.2707C33.3929 57.6907 33.0391 58.0313 32.6027 58.0313ZM37.6071 68.1719H33.3929V62.848C33.3929 62.428 33.7467 62.0875 34.183 62.0875H36.817C37.2533 62.0875 37.6071 62.428 37.6071 62.848V68.1719ZM41.8214 57.2707C41.8214 57.6907 41.4676 58.0313 41.0313 58.0313H38.3973C37.9609 58.0313 37.6071 57.6907 37.6071 57.2707V54.7355C37.6071 54.3155 37.9609 53.975 38.3973 53.975H41.0313C41.4676 53.975 41.8214 54.3155 41.8214 54.7355V57.2707ZM41.8214 51.1863C41.8214 51.6063 41.4676 51.9469 41.0313 51.9469H38.3973C37.9609 51.9469 37.6071 51.6063 37.6071 51.1863V48.6512C37.6071 48.2312 37.9609 47.8906 38.3973 47.8906H41.0313C41.4676 47.8906 41.8214 48.2312 41.8214 48.6512V51.1863ZM41.8214 45.102C41.8214 45.522 41.4676 45.8625 41.0313 45.8625H38.3973C37.9609 45.8625 37.6071 45.522 37.6071 45.102V42.5668C37.6071 42.1468 37.9609 41.8063 38.3973 41.8063H41.0313C41.4676 41.8063 41.8214 42.1468 41.8214 42.5668V45.102Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8381_49582)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69.5,
    cy: 23.5,
    r: 19.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.5,
    cy: 23.5,
    r: 19,
    stroke: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.455 23.5C85.455 32.3134 78.3113 39.4545 69.5004 39.4545C60.6896 39.4545 53.5459 32.3134 53.5459 23.5C53.5459 14.6917 60.6896 7.54541 69.5004 7.54541C78.3113 7.54541 85.455 14.6917 85.455 23.5ZM69.5004 26.7166C67.8661 26.7166 66.5411 28.0415 66.5411 29.6759C66.5411 31.3103 67.8661 32.6352 69.5004 32.6352C71.1348 32.6352 72.4598 31.3103 72.4598 29.6759C72.4598 28.0415 71.1348 26.7166 69.5004 26.7166ZM66.6908 16.0794L67.1681 24.8287C67.1904 25.2381 67.5289 25.5586 67.9389 25.5586H71.062C71.472 25.5586 71.8105 25.2381 71.8328 24.8287L72.3101 16.0794C72.3342 15.6372 71.9821 15.2654 71.5392 15.2654H67.4616C67.0187 15.2654 66.6667 15.6372 66.6908 16.0794V16.0794Z",
    fill: "#FF0000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8381_49582",
    x: 0,
    y: 21,
    width: 71,
    height: 71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8381_49582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8381_49582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8381_49582",
    x: 46,
    y: 0,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.960784 0 0 0 0 0.133333 0 0 0 0 0.176471 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8381_49582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8381_49582",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgesDisabled);
export default __webpack_public_path__ + "static/media/badges-disabled.83d4ae266b38e42f86d45edc4e9a87e0.svg";
export { ForwardRef as ReactComponent };